import { FEATURE_NAME } from 'src/redesign/features/Toast/store/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastNotificationsState } from 'src/redesign/features/Toast/types';
import { ToastProps } from 'src/redesign/features/Toast/index';

const initialState: ToastNotificationsState = {
  current: null,
};

export const toastNotificationsSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<ToastProps>) => {
      state.current = action.payload;
    },
  },
});
